module.exports = __webpack_public_path__ + "img/google_security.8087117f.webp";